import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SubscriptionStates } from "./utils/constants";

const resources = {
  en: {
    translation: {
      subscriptionManagement: "Subscription Management",
      themeToggle: {
        darkMode: "Dark Mode",
        lightMode: "Light Mode",
      },
      loading: "Loading...",
      subscription: {
        title: "Thank you for your subscription",
        verificationMessage:
          "Please verify the following information is correct before submitting your subscription for activation by Hypernovalabs S.A.",
        details: {
          currentUser: "Current user",
          email: "Email",
          subscriptionName: "Subscription name",
          planName: "Plan name",
          subscriptionState: "Subscription State",
          tenantId: "Tenant ID",
          unknown: "Unknown"
        },
        actions: "Available Customer Actions",
        notifyActivation: "Notify publisher to activate account",
        unsubscribe: "Unsubscribe",
        subscriptionError: "There was an error trying to subscribe your tenant"
      },
      subscriptionStates: {
        [SubscriptionStates.PENDINGFULLFILMENT]: "Pending Fulfillment",
        [SubscriptionStates.SUBSCRIBED]: "Active",
        [SubscriptionStates.SUSPENDED]: "Suspended",
        [SubscriptionStates.UNSUBSCRIBED]: "Unsubscribed",
      },
      unsubscribe: {
        loading: "Processing your unsubscription...",
        title: "We're sorry to see you go!",
        message:
          "You have successfully unsubscribed from our service. We hope to have the opportunity to serve you again in the future. If you have any questions or need further assistance, please contact our support team.",
        errorTitle: "Unsubscription Error",
      },
      notifyActivated: {
        loading: 'Activating your subscription...',
        title: 'Welcome!',
        message1: 'Thank you for choosing aludra VR. We are excited to have you on board.',
        message2: 'Please watch for an email from us with further details on next steps.',
        errorTitle: 'Activation Error'
      },
      loadingComponent: {
        initialLoading: 'Loading...',
        processingRequest: 'Processing Request',
        stepCounter: 'Step {{currentStep}} of {{totalSteps}}',
        networkError: 'Network response was not ok',
        errorTitle: 'Error',
        errorMessage: 'There was an error trying to create your account, please refer to our support page'
      },
      support: {
        haveQuestions: "¿Have questions?",
        visitSite: "Visit our support page",
      },
      error: {
        tokenInvalid: "Invalid or Expired Token",
        tokenError:
          "The token provided is either invalid or has expired. Please check your subscription link and try again.",
      },
      footer: {
        copyright: "© {{year}} Hypernovalabs S.A. All Rights Reserved.",
      },
    },
  },
  es: {
    translation: {
      subscriptionManagement: "Gestión de Suscripción",
      themeToggle: {
        darkMode: "Modo Oscuro",
        lightMode: "Modo Claro",
      },
      loading: "Cargando...",
      subscription: {
        title: "Gracias por su suscripción",
        verificationMessage:
          "Por favor, verifique que la siguiente información sea correcta antes de enviar su suscripción para activación por Hypernovalabs S.A.",
        details: {
          currentUser: "Usuario actual",
          email: "Correo electrónico",
          subscriptionName: "Nombre de suscripción",
          planName: "Nombre del plan",
          subscriptionState: "Estado de suscripción",
          tenantId: "ID de inquilino",
          unknown: "Desconocido"
        },
        actions: "Acciones disponibles para el cliente",
        notifyActivation: "Notificar al editor para activar la cuenta",
        unsubscribe: "Cancelar suscripción",
        subscriptionError: "Hubo un error al intentar subscribir su compañía"
      },
      subscriptionStates: {
        [SubscriptionStates.PENDINGFULLFILMENT]: "Pendiente de cumplimiento",
        [SubscriptionStates.SUBSCRIBED]: "Activo",
        [SubscriptionStates.SUSPENDED]: "Suspendido",
        [SubscriptionStates.UNSUBSCRIBED]: "No suscrito",
      },
      unsubscribe: {
        loading: "Procesando su baja...",
        title: "¡Lamentamos verle ir!",
        message:
          "Ha cancelado su suscripción con éxito. Esperamos tener la oportunidad de servirle nuevamente en el futuro. Si tiene alguna pregunta o necesita más ayuda, por favor contacte a nuestro equipo de soporte.",
        errorTitle: "Error en la baja",
      },
      notifyActivated: {
        loading: 'Activando su suscripción...',
        title: '¡Bienvenido!',
        message1: 'Gracias por elegir aludra VR. Estamos emocionados de tenerlo a bordo.',
        message2: 'Esté atento a un correo electrónico de nuestra parte con más detalles sobre los próximos pasos.',
        errorTitle: 'Error de Activación'
      },
      loadingComponent: {
        initialLoading: 'Cargando...',
        processingRequest: 'Procesando Solicitud',
        stepCounter: 'Paso {{currentStep}} de {{totalSteps}}',
        networkError: 'La respuesta de red no fue correcta',
        errorTitle: 'Error',
        errorMessage: 'Hubo un error al intentar crear su cuenta, por favor consulte nuestra página de soporte'
      },
      support: {
        haveQuestions: "¿Tienes dudas?",
        visitSite: "Visita nuestra web de soporte",
      },
      error: {
        tokenInvalid: "Token inválido o expirado",
        tokenError:
          "El token proporcionado no es válido o ha expirado. Verifique el enlace de suscripción e intente nuevamente.",
      },
      footer: {
        copyright:
          "© {{year}} Hypernovalabs S.A. Todos los derechos reservados.",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
